import React from "react";
import Loadable from "../../../react-loadable";
// import Browser from "./Browser";
// import BrowserList from "./BrowserList";
// import Upload from "./Upload";
// import At from "./At";
// import WordImport from "./WordImport";

const Browser = Loadable({
  loader: () => import("./Browser"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const Upload = Loadable({
  loader: () => import("./Upload"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const BrowserList = Loadable({
  loader: () => import("./BrowserList"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const At = Loadable({
  loader: () => import("./At"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const WordImport = Loadable({
  loader: () => import("./WordImport"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default {
  Browser,
  Upload,
  BrowserList,
  At,
  WordImport
};



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/plugins/index.js